import moment from "moment-timezone";
import Dinero from "dinero.js";
import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Card, List } from "semantic-ui-react";

import ResourceMarker from "../marking/ResourceMarker.jsx";
import LinkWithReset from "../utils/LinkWithReset.jsx";

import { COST_FORMAT } from "../config.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class InvoiceCard extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired
  };

  // -- RENDER -- //

  render = () => {
    const { data, copy } = this.props;

    const total = Dinero({
      amount: data.summary.total,
      currency: data.summary.currency
    }).setLocale("en-GB");

    return (
      <Card fluid as={LinkWithReset} to={data["@id"]} className="invite-card">
        <Card.Content>
          <ResourceMarker marking={data.marking} className="float-right" />
          <Card.Header>{`${copy("invoice_card.invoice")}: ${
            data.number
          }`}</Card.Header>
        </Card.Content>
        <Card.Content>
          <p>
            <strong>{`${copy("invoice_card.week")}: `}</strong>
            {moment(data.startAt).utc().format("W")}*
          </p>
          <List horizontal relaxed>
            <List.Item>
              <List.Content>
                <strong>{`${copy("invoice_card.date")}: `}</strong>
                <br />
                {`${moment(data.startAt).utc().format("DD/MM/YYYY")} - ${moment(
                  data.endAt
                )
                  .utc()
                  .format("DD/MM/YYYY")}`}
                {"*"}
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <strong>{`${copy("invoice_card.total")}: `}</strong>
                <br />
                {` ${total.toFormat(COST_FORMAT)}`}
              </List.Content>
            </List.Item>
          </List>
        </Card.Content>
      </Card>
    );
  };
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(InvoiceCard);
